import React, { useState } from "react";
import classes from "./Dropdown.module.css";
import { dropdownData } from "./dropdownData";
import { AiOutlineRight } from "react-icons/ai";
import Dropdown from "./SubDropDown/Dropdown";

const productData = [
  { name: "ITS", path: "/products/its" },
  { name: "Mazza", path: "/products/mazza" },
  { name: "Bruggen", path: "/products/bruggen" },
  { name: "9AM", path: "/products/9am" },
  { name: "CREAMOOZ", path: "/products/creamooz" },
  { name: "PURE", path: "/products/pure" },
  { name: "CHAT", path: "/products/chat" },
];

const hardwareData = [
  { name: "Plank", path: "/products/plank" },
  { name: "Square", path: "/products/square" },
];

const DropdownMenu = () => {
  const [toggleProductDropDown, setToggleProductDropDown] = useState(false);
  const [toggleHardwareDropDown, setToggleHardwareDropDown] = useState(false);
  const showProductDropDown = () => {
    setToggleProductDropDown(true);
  };
  const hideProductDropDown = () => {
    setToggleProductDropDown(false);
  };

  const showhardwareDropDown = () => {
    setToggleHardwareDropDown(true);
  };
  const hidehardwareDropDown = () => {
    setToggleHardwareDropDown(false);
  };

  return (
    <div className={classes.dropdown}>
      {dropdownData.map((data, index) => {
        const { name } = data;
        return (
          <h2
            key={index}
            onMouseEnter={
              name === "FMGC"
                ? showProductDropDown
                : name === "Hardware"
                ? showhardwareDropDown
                : undefined
            }
            onMouseLeave={
              name === "FMGC"
                ? hideProductDropDown
                : name === "Hardware"
                ? hidehardwareDropDown
                : undefined
            }
          >
            {name} <AiOutlineRight />
            {name === "FMGC" && toggleProductDropDown && (
              <Dropdown data={productData} />
            )}
            {name === "Hardware" && toggleHardwareDropDown && (
              <Dropdown data={hardwareData} />
            )}
          </h2>
        );
      })}
    </div>
  );
};

export default DropdownMenu;
